import React from 'react';

import { TabbedShowLayout, Tab } from 'react-admin';
import CommonTab from './DeliveryTabs/CommonTab';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    '& > *:first-child': {
      marginLeft: '16px'
    }
  }
});
const DeliveryStep = props => {
  const classes = useStyles();

  return (
    <TabbedShowLayout className={classes.root}>
      <Tab label="Online Reporting E-Mail">
        <CommonTab {...props} notificationMethod="REPORTING" />
      </Tab>
      <Tab label="E-Mail Documents">
        <CommonTab {...props} notificationMethod="EMAIL" />
      </Tab>
      <Tab label="Mail Documents">
        <CommonTab {...props} notificationMethod="MAIL" />
      </Tab>
    </TabbedShowLayout>
  );
};
export default DeliveryStep;
